<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="12">
        <p class="gray--text mb-5 list-modality__title">
          SEGURADORA: {{ insurance.nome }}
        </p>
        <p class="font-weight-bold primary--text mb-2">
          MODALIDADE {{ modality.nome }}
        </p>
      </v-col>
      <v-col cols="12" class="py-5" v-if="isEdit">
        <v-switch
          v-model="editForm.ativo"
          class="pa-0 ma-0 justify-self-center d-inline-block insurance-step-modality__switch"
          inset
          dense
          hide-details
          color="secondary"
        />
        <p class="pl-1 mb-0 d-inline-block darkBluishGray--text body-2">
          {{ isActivate(editForm) }}
        </p>
      </v-col>
      <v-col cols="12">
        <p class="font-weight-regular mb-2 primary--text">
          Prazo estimado em dias
        </p>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <BaseFormInput
          id-element="draftContractModalityInsurance"
          placeholder="Inserir"
          v-model="editForm.prazo_minuta_dias"
          required
          :rules="[requiredInput]"
          label-text="Minuta"
          type="number"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <BaseFormInput
          id-element="policyContractModalityInsurance"
          placeholder="Inserir"
          v-model="editForm.prazo_apolice_dias"
          required
          :rules="[requiredInput]"
          label-text="Apólice"
          type="number"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="4" class="pr-sm-5">
        <BaseMoney
          id-element="valueModalityInsurance"
          placeholder="Inserir"
          v-model="editForm.valor_emissao_sem_ccg"
          required
          :rules="[requiredInput]"
          label-text="Emissão s/CCG"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <BaseFormSelect
          id-element="paymentModalityInsurance"
          placeholder="Inserir"
          v-model="editForm.forma_pagamento"
          required
          :rules="[requiredInput]"
          label-text="Forma de Pagamento (Padrão)"
          :items="listPaymentMethods"
          item-text="nome"
          item-value="id"
          :return-object="true"
        />
      </v-col>
      <v-col cols="12" class="pb-11 pt-5">
        <v-divider />
      </v-col>
      <v-col cols="12">
        <p class="font-weight-bold mb-5 primary--text">
          SUB-MODALIDADE
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="4" xl="3" class="pb-5">
        <BaseButton
          class="secondary white--text"
          width="100%"
          @click="addSubModality"
          v-if="checkAllSubModalitiesAdded"
        >
          <v-icon class="pr-3">
            fa-plus
          </v-icon>
          INSERIR SUBMODALIDADE
        </BaseButton>
      </v-col>
      <v-spacer />
      <v-col
        cols="12"
        sm="5"
        md="3"
        class="pb-5"
        v-if="selectedSubModality.length > 0"
      >
        <BaseButton
          v-html="'EXCLUIR SUBMODALIDADE'"
          color="pink"
          width="100%"
          outlined
          @click="removeSelectedSubModality"
        />
      </v-col>
      <v-col cols="12" class="pb-11">
        <BaseDataTable
          :headers="header"
          :items="itemsSubModality"
          show-select
          item-key="submodalidade.nome"
          v-model="selectedSubModality"
          hide-default-footer
        >
          <template v-slot:[`item.submodalidade.nome`]="{ item }">
            <div @click="editItem(item)">
              {{ item.submodalidade.nome }}
            </div>
          </template>
          <template v-slot:[`item.prazo_minuta_dias`]="{ item }">
            <div @click="editItem(item)">{{ item.prazo_minuta_dias }} dias</div>
          </template>
          <template v-slot:[`item.prazo_apolice_dias`]="{ item }">
            <div @click="editItem(item)">
              {{ item.prazo_apolice_dias }} dias
            </div>
          </template>
          <template v-slot:[`item.valor_emissao_sem_ccg`]="{ item }">
            <div @click="editItem(item)">
              {{ convertNumberToMoney(item.valor_emissao_sem_ccg) }}
            </div>
          </template>
          <template v-slot:[`item.possui_api`]="{ item }">
            <div @click="editItem(item)">
              {{ hasApi(item) }}
            </div>
          </template>
          <template v-slot:[`item.ativo`]="{ item }">
            <div @click="editItem(item)">
              {{ isActivate(item) }}
            </div>
          </template>
        </BaseDataTable>
      </v-col>
    </v-row>
    <BaseFooter>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="5" md="3" class="pr-sm-5 pb-5 pb-sm-0">
          <BaseButton
            v-html="'CANCELAR'"
            class="white--text pink"
            width="100%"
            @click="openModalCancel"
          />
        </v-col>
        <v-col cols="12" sm="5" md="3">
          <BaseButton
            v-html="'SALVAR'"
            class="white--text secondary"
            width="100%"
            @click="submit"
            :disabled="emptyListSubModalities"
          />
        </v-col>
      </v-row>
    </BaseFooter>
    <ModalCancelModality
      @close="closeModalCancel"
      v-model="modalCancelModality"
      title="SAIR SEM SALVAR"
      text="As alterações não foram salvas. Deseja realmente sair da tela?"
    />
  </v-form>
</template>
<script>
const tableHeaders = [
  { text: "Submodalidade", value: "submodalidade.nome", sortable: true },
  { text: "Prazo Emissão Minuta", value: "prazo_minuta_dias", sortable: true },
  {
    text: "Prazo Emissão Apólice",
    value: "prazo_apolice_dias",
    sortable: true
  },
  { text: "Limite sem CCG", value: "valor_emissao_sem_ccg", sortable: true },
  { text: "Possui API", value: "possui_api", sortable: true },
  { text: "Status", value: "ativo", sortable: true }
];
import { requiredInput } from "@/utils/rules.js";
import { InsuranceCompanyMixin } from "@/mixins/NewInsuranceCompanyMixin";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import { mapState, mapActions } from "vuex";
import _ from "lodash";
import { asMoneyString, convertNumberToMoney } from "@/utils/formats.js";
import ModalCancelModality from "../../insurance_company/components/ModalCancelInsurance";
export default {
  data: () => ({
    header: tableHeaders,
    selectedSubModality: [],
    itemsSubModality: [],
    requiredInput,
    asMoneyString,
    convertNumberToMoney,
    modalCancelModality: false,
    editForm: {},
    isEdit: false
  }),
  mixins: [LoadingRequest, InsuranceCompanyMixin],
  components: {
    ModalCancelModality
  },
  computed: {
    ...mapState("quotation", ["listSubModality"]),
    ...mapState("insuranceCompany", ["listPaymentMethods"]),
    listActiveSubModality() {
      return this.listSubModality.filter(x => x.ativo == true);
    },
    modalityStep() {
      return {
        name: "insurance_company step modality",
        step: 2
      };
    },
    selectModalityStep() {
      return {
        name: "insurance_company select modality",
        step: 2
      };
    },
    selectSubModalityStep() {
      return {
        name: "insurance_company select sub modality",
        step: 2
      };
    },
    editSubModality() {
      return {
        name: "insurance_company edit sub modality",
        step: 2
      };
    },
    checkAllSubModalitiesAdded() {
      return !(
        this.itemsSubModality.length == this.listActiveSubModality.length
      );
    },
    emptyListSubModalities() {
      return this.itemsSubModality.length == 0;
    }
  },
  async created() {
    this.editForm = _.cloneDeep(this.form);
    this.isEdit = Boolean(this.editForm.modalidade);
    this.updateSubModality();
    await this.fetchSubModality();
  },
  methods: {
    ...mapActions("quotation", ["requestSubModalities"]),
    ...mapActions("insuranceCompany", ["requestPaymentMethods"]),
    previousStep() {
      this.$emit(
        "updateStep",
        this.payloadInsuranceCompany(this.form, this.modalityStep)
      );
    },
    submit() {
      if (this.$refs.form.validate())
        this.$emit(
          "updateModality",
          this.payloadInsuranceCompany(this.editForm, this.modalityStep)
        );
    },
    updateSubModality() {
      // Guardar toda vez a modalidade escolhida
      // no formulário para adicionar a lista de
      // modalidades caso o formulário seja concluído
      if (!this.editForm.modalidade) this.editForm.modalidade = this.modality;
      if (!this.editForm.submodalidades) this.editForm.submodalidades = [];
      this.itemsSubModality = this.editForm.submodalidades;
      // } else {
      //   // APENAS EM EDIÇÃO
      //   // checar se as submodalidades pertencem
      //   // a modalidade escolhida, caso o usuário
      //   // tenha trocado a modalidade, devo deletar as
      //   // submodalidades já existentes.
      //   this.form.submodalidades = this.form.submodalidades.filter(
      //     x => _.findIndex(this.listSubModality, x.submodalidade) > -1
      //   );
      //   this.itemsSubModality = this.form.submodalidades;
      // }
    },
    hasApi(item) {
      return item.possui_api ? "Sim" : "Não";
    },
    isActivate(item) {
      return item.ativo ? "Ativo" : "Inativo";
    },
    fetchSubModality() {
      this.withLoading(
        Promise.all([
          this.requestSubModalities(
            (this.form.modalidade && this.form.modalidade.id) ||
              this.modality.id
          ),
          this.requestPaymentMethods()
        ])
      );
    },
    addSubModality() {
      if (
        this.editForm.submodalidades &&
        this.editForm.submodalidades.length > 0
      ) {
        this.$emit(
          "new",
          this.payloadInsuranceCompany(
            this.editForm,
            this.selectSubModalityStep
          )
        );
      } else {
        if (this.$refs.form.validate()) this.updateListSubModality();
      }
    },
    updateListSubModality() {
      this.editForm.submodalidades = [];
      // Na primeira vez que for adicionar submodalidade
      // será adicionado todas as submodalidades ativas
      // com os mesmos valores da modalidade
      this.listActiveSubModality.forEach(element => {
        const payload = {
          submodalidade: element,
          possui_api: false,
          prazo_minuta_dias: this.editForm.prazo_minuta_dias,
          prazo_apolice_dias: this.editForm.prazo_apolice_dias,
          valor_emissao_sem_ccg: this.editForm.valor_emissao_sem_ccg,
          forma_pagamento: this.editForm.forma_pagamento,
          texto_disclaimer: null,
          ativo: true
        };
        this.editForm.submodalidades.push(payload);
      });
      this.itemsSubModality = this.editForm.submodalidades;
    },
    editItem(item) {
      this.$emit(
        "edit",
        this.payloadInsuranceCompany(this.editForm, this.editSubModality, item),
        this.itemsSubModality.indexOf(item)
      );
    },
    removeSelectedSubModality() {
      this.editForm.submodalidades = this.editForm.submodalidades.filter(
        item => !this.selectedSubModality.includes(item)
      );
      this.itemsSubModality = this.editForm.submodalidades;
      this.selectedSubModality = [];
    },
    openModalCancel() {
      this.modalCancelModality = true;
    },
    closeModalCancel(value) {
      this.cancel = value;
      this.modalCancelModality = false;
      if (value) {
        this.previousStep();
      } else {
        this.$emit("setReturnFalse");
      }
    }
  },
  props: {
    return: {
      type: Boolean
    },
    insurance: {
      type: Object
    },
    modality: {
      type: Object
    },
    form: {
      type: Object
    }
  },
  watch: {
    return(value) {
      value && this.openModalCancel();
    }
  }
};
</script>
